import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import usePageTitle from '../hooks/usePageTitle';
import api from '../services/api';
import './CreateEvent.css';

const CreateEvent = () => {
  usePageTitle('Create Event');
  const [formData, setFormData] = useState({
    title: '',
    description: '',
    event_date: '',
    event_time: '',
    poster: null,
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { isFounder } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    if (e.target.type === 'file') {
      setFormData({ ...formData, poster: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const data = new FormData();
      data.append('title', formData.title);
      data.append('description', formData.description);
      data.append('event_date', formData.event_date);
      data.append('event_time', formData.event_time);
      if (formData.poster) {
        data.append('poster', formData.poster);
      }

      await api.post('/events', data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      alert('Event created successfully!');
      navigate('/events');
    } catch (err) {
      setError(err.response?.data?.message || 'Error creating event');
      console.error('Error creating event:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!isFounder) {
    return (
      <div className="unauthorized-container">
        <div className="unauthorized-message">
          <h2>🚫 Unauthorized</h2>
          <p>You are not authorized to access this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="create-event-container">
      <div className="create-event-card">
        <div className="form-header">
          <h2>✨ Create New Event</h2>
          <button className="btn-close" onClick={() => navigate('/events')}>
            ✕
          </button>
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>📝 Event Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter event title"
              required
            />
          </div>

          <div className="form-group">
            <label>📄 Description</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Enter event description"
              rows="5"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>📅 Event Date</label>
              <input
                type="date"
                name="event_date"
                value={formData.event_date}
                onChange={handleChange}
                min={new Date().toISOString().split('T')[0]}
                required
              />
            </div>

            <div className="form-group">
              <label>🕐 Event Time</label>
              <input
                type="time"
                name="event_time"
                value={formData.event_time}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label>🖼️ Event Poster (Optional)</label>
            <div className="file-upload-wrapper">
              <input
                type="file"
                name="poster"
                accept="image/*"
                onChange={handleChange}
                className="file-input"
                id="poster-upload"
              />
              <label htmlFor="poster-upload" className="file-upload-label">
                {formData.poster ? formData.poster.name : 'Choose Image'}
              </label>
            </div>
            {formData.poster && (
              <div className="preview-container">
                <img
                  src={URL.createObjectURL(formData.poster)}
                  alt="Poster preview"
                  className="poster-preview"
                />
              </div>
            )}
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={() => navigate('/events')}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={loading}
            >
              {loading ? 'Creating...' : '✨ Create Event'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateEvent;




